import React from 'react'
import Bookingform from '../Components/BookApartment/Bookingform'
import HNavBar from '../Components/Home/HNavbar/HNavbar'

const BookApartment = () => {
  return (
    <div>
        <HNavBar/>
        <Bookingform/>
    </div>
  )
}

export default BookApartment
